import gql from 'graphql-tag';

const QUERY_GET_EMAIL_FROM_ID = gql`
	query GetEmailFromID($id: String!) {
		getEmailFromID(id: $id)
	}

`;

export default QUERY_GET_EMAIL_FROM_ID;